import { render, staticRenderFns } from "./PastBookingTicket.vue?vue&type=template&id=45a49511&scoped=true&"
import script from "./PastBookingTicket.vue?vue&type=script&setup=true&lang=js&"
export * from "./PastBookingTicket.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PastBookingTicket.vue?vue&type=style&index=0&id=45a49511&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a49511",
  null
  
)

export default component.exports